import Swiper from 'swiper/bundle';

/**
 * FooterSwiper - A class for handling footer-based swiper sliders
 */
class FooterSwiper {
	/**
	 * Find every container, instantiate a slider on each
	 */
	static setup() {
		document.querySelectorAll('.footer-use-cases').forEach((containerEl) => {
			const slider = new FooterSwiper(containerEl);
			slider.init();
		});
	}

	/**
	 * @param {HTMLElement} containerEl
	 *   The element wrapping both your slides (.use-cases-slider)
	 *   and your controls (.swiper-pagination, .swiper-button-next/prev)
	 */
	constructor(containerEl) {
		this.container = containerEl;
		// inside that container, find the actual slider root
		this.sliderEl = containerEl.querySelector('.use-cases-slider');
		this.swiperInstance = null;
	}

	/**
	 * Kick things off
	 */
	init() {
		if (!this.sliderEl) {
			console.warn('FooterSwiper: no .use-cases-slider inside', this.container);
			return;
		}
		this.setupSwiper();
	}

	/**
	 * (Re)initializes the Swiper instance
	 */
	setupSwiper() {
		// destroy old instance if re‑initializing
		if (this.swiperInstance) {
			this.swiperInstance.destroy(true, true);
			this.swiperInstance = null;
		}

		// build new one on the inner sliderEl, but pull controls from the outer container
		this.swiperInstance = new Swiper(this.sliderEl, {
			slidesPerView: 1,
			loop: true,
			autoplay: false,

			// pagination pulled from the container
			pagination: {
				el: this.container.querySelector('.swiper-pagination'),
				clickable: true,
			},
			// navigation pulled from the container
			navigation: {
				nextEl: this.container.querySelector('.swiper-button-next'),
				prevEl: this.container.querySelector('.swiper-button-prev'),
			},
		});
	}
}

// DOM ready check
if (document.readyState === 'interactive' || document.readyState === 'complete') {
	FooterSwiper.setup();
} else {
	document.addEventListener('DOMContentLoaded', FooterSwiper.setup);
}
